import { render, staticRenderFns } from "./AboutUsBLock.vue?vue&type=template&id=6165f0ea&scoped=true"
import script from "./AboutUsBLock.vue?vue&type=script&lang=js"
export * from "./AboutUsBLock.vue?vue&type=script&lang=js"
import style0 from "./AboutUsBLock.vue?vue&type=style&index=0&id=6165f0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165f0ea",
  null
  
)

export default component.exports